import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { getEndpoint } from 'src/app/core/services/functions.service';

export interface TipoNovedad {
  codigo: string;
  descripcion: string;
}

@Injectable({
  providedIn: 'root'
})
export class TipoNovedadService {
  ENDPOINT = getEndpoint('coms_tipo_novedad_comision');

  constructor(private http: HttpClient) { }

  getTiposNovedad(company: string): Observable<TipoNovedad[]> {
    return this.http.get<TipoNovedad[]>(`${this.ENDPOINT}/list`, {
      headers: { 'company': company }
    });
  }
}
